// extracted by mini-css-extract-plugin
export var contactLink = "contact-module--contact-link--1e477";
export var contactMainWrapper = "contact-module--contact-main-wrapper--45749";
export var contactSection = "contact-module--contact-section--799f5";
export var firstRow = "contact-module--first-row--3ee4d";
export var googleMapIframe = "contact-module--google-map-iframe--4d497";
export var headerImage = "contact-module--header-image--8598a";
export var secondRow = "contact-module--second-row--83734";